import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { GroupNumberService } from '../../../services/group-number.service';
import { AppState } from '../../app.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-select-province-modal',
  imports: [CommonModule, FormsModule],
  templateUrl: './select-province-modal.component.html',
  styleUrl: './select-province-modal.component.scss'
})
export class SelectProvinceModalComponent {
    public provinces;
    public selectedProvince: string;
    public showError = false;
  constructor(
    private dialogRef: MatDialogRef<any>,
    private numberGroupService: GroupNumberService,
    private appState: AppState

  ) { }
  ngOnInit(): void {
    document.body.classList.add('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.removeAttribute('aria-hidden');
    }
    this.appState.loading = true;
    this.numberGroupService.getProvinces().then((data) => {
        this.appState.loading = false;
        this.provinces = data.provinces;
        this.provinces = this.provinces.filter((p) => p !== 'QC')
    }, (error) => {
        this.appState.loading = false;
        this.closeDialog();
    })
  }

  ngOnDestroy(): void {
    document.body.classList.remove('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.setAttribute('aria-hidden', 'true');
    }
  }
    selectProvince(): void {
        console.info('selected province ', this.selectedProvince)
        if (this.selectedProvince) {
            this.showError = false;
            
            this.closeDialog(this.selectedProvince);
        } else {
            this.showError = true;
        }
    }
  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  closeDialog(res?: any): void {
    this.beforeClose();
    this.dialogRef.close(res);
  }
}
